import classes from './ValidationMessage.module.scss'
import type { ReactNode } from 'react'

interface Props {
  isValid: boolean
  isEmpty?: boolean
  children: ReactNode
}

const ValidationMessage = ({
  isValid,
  isEmpty = false,
  children
}: Props) => {
  const withInputClassName = isValid
    ? classes.ValidationMessageValid
    : classes.ValidationMessageInvalid

  const wrapperClassName = isEmpty
    ? classes.NoInput
    : withInputClassName

  return (
    <span className={wrapperClassName}>
      {children}
    </span>
  )
}

export default ValidationMessage
